import { t as translate } from 'i18next';

import userDefaultIcon from '../../assets/icons/v3/user-picture.svg?url';
import { FLEXIBLE_REMUNERATION_BENEFITS } from '../constants/flexibleRemuneration';
import { IRankingCardData, IRankingDataItem } from '../interfaces/cards';
import { IFlexibleRemunerationConsumptionRanking, IFlexibleRemunerationPayRollCycle } from '../interfaces/company';
import { IMetricsRanking, ITopBenefit } from '../interfaces/metrics';
import { IReport } from '../interfaces/reports';
import { toTitleCase } from '../utils/utils';

export const mapToRankingDataItem = (item: IRankingDataItem): IRankingDataItem => ({
  title: item.title ? toTitleCase(item.title) : '',
  id: item.id,
  icon: item.icon && item.icon !== '' ? item.icon : userDefaultIcon,
  value: item.value
});

export const mapToRankingCardData = (data: IMetricsRanking): IRankingCardData => {
  const rankingKey = Object.keys(data)[0];
  if (!data || data[rankingKey].length === 0) {
    return {};
  }
  const rankingCardData: IRankingCardData = {
    [rankingKey]: {
      name: rankingKey,
      id: rankingKey,
      data: data[rankingKey].map(mapToRankingDataItem)
    }
  };
  return rankingCardData;
};

export const mapRFConsumptionRankingCardData = (data: IFlexibleRemunerationConsumptionRanking[]): IRankingCardData => {
  const rankingKey = 'ranking';
  if (!data || data.length === 0) {
    return {};
  }
  const rankingCardData: IRankingCardData = {
    [rankingKey]: {
      name: rankingKey,
      id: rankingKey,
      data: data.map((item) => ({
        title: translate(FLEXIBLE_REMUNERATION_BENEFITS[item.sku].title),
        id: item.sku,
        icon: FLEXIBLE_REMUNERATION_BENEFITS[item.sku].icon
          ? FLEXIBLE_REMUNERATION_BENEFITS[item.sku].icon
          : userDefaultIcon,
        value: item.accumulatedBalance
      }))
    }
  };
  return rankingCardData;
};

export const mapRankingCardDataFromChart = (data: ITopBenefit[]): IRankingCardData => {
  const rankingKey = 'ranking';
  if (!data || data.length === 0) {
    return {};
  }
  const rankingCardData: IRankingCardData = {
    [rankingKey]: {
      name: rankingKey,
      id: rankingKey,
      data: data.map((item) => ({
        title: toTitleCase(item.name),
        id: item.id.toString(),
        icon: item.icon && item.icon !== '' ? item.icon : userDefaultIcon,
        value: item.value
      }))
    }
  };
  return rankingCardData;
};

export const getMappedReports = (payRollCycles: IFlexibleRemunerationPayRollCycle[]): IReport[] =>
  payRollCycles.map((item) => ({
    id: item.id,
    generationDate: item.endDay,
    lastUpdate: '',
    period: `${item.cycleYear}-${item.cycleMonth}-01`,
    status: item.status
  }));
